// extracted by mini-css-extract-plugin
export default {"confettiContainer":"LO0OJ","confetti":"QF1l8"};